module.exports = {
  transparent: {
    h: 0,
    s: '0%',
    l: '0%',
    a: 0,
  },

  white: {
    h: 0,
    s: '0%',
    l: '100%',
  },
  smoke: {
    h: 0,
    s: '0%',
    l: '97%',
  },
  whisper: {
    h: 0,
    s: '0%',
    l: '93%',
  },
  silver: {
    h: 0,
    s: '0%',
    l: '85%',
  },
  grey: {
    h: 0,
    s: '0%',
    l: '65%',
  },
  ash: {
    h: 0,
    s: '0%',
    l: '35%',
  },
  coal: {
    h: 0,
    s: '0%',
    l: '15%',
  },
  black: {
    h: 0,
    s: '0%',
    l: '0%',
  },

  danger: {
    h: 360,
    s: '90%',
    l: '60%',
  },
  warning: {
    h: 35,
    s: '90%',
    l: '55%',
  },
  success: {
    h: 145,
    s: '65%',
    l: '40%',
  },
}
